var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "400px",
        "append-to-body": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            { attrs: { "label-position": "left", "label-width": "70px" } },
            [
              _vm.type === 0
                ? _c(
                    "div",
                    [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_AllocationCancel"))
                        )
                      ]),
                      _c("br"),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: {
                            "padding-top": "20px",
                            "padding-bottom": "20px"
                          },
                          attrs: { no: "cancelCabin" },
                          model: {
                            value: _vm.cancelCabin,
                            callback: function($$v) {
                              _vm.cancelCabin = $$v
                            },
                            expression: "cancelCabin"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CabinReturn")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.type === 1 || _vm.cancelCabin
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_CabinCancellationExplanation"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "285px" },
                        attrs: { no: "note", type: "textarea", rows: 10 },
                        model: {
                          value: _vm.note,
                          callback: function($$v) {
                            _vm.note = $$v
                          },
                          expression: "note"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }